module.exports = __webpack_public_path__ + "static/img/i146.121a3cb8.png";